/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WebhookDeliveryDto } from '../../models/webhook-delivery-dto';

export interface WebhooksMonitoringEventsWebhookEventIdDeliveriesGet$Plain$Params {
  webhookEventId: string;
}

export function webhooksMonitoringEventsWebhookEventIdDeliveriesGet$Plain(http: HttpClient, rootUrl: string, params: WebhooksMonitoringEventsWebhookEventIdDeliveriesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WebhookDeliveryDto>>> {
  const rb = new RequestBuilder(rootUrl, webhooksMonitoringEventsWebhookEventIdDeliveriesGet$Plain.PATH, 'get');
  if (params) {
    rb.path('webhookEventId', params.webhookEventId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WebhookDeliveryDto>>;
    })
  );
}

webhooksMonitoringEventsWebhookEventIdDeliveriesGet$Plain.PATH = '/webhooks/monitoring/events/{webhookEventId}/deliveries';
